import React from 'react'

import { ZariContext } from '_zari/context'
import { Modal, Button, Form, Col } from '_zari/core'

import * as AsientoContableService from 'services/asientosContables.service'
import * as CuentaContableService from 'services/cuentaContable.service'

const EditarDestino = ({ handleClose, show, idEdicion, reloadTable }) => {
  const __zariContext = React.useContext(ZariContext)

  const [cuentasContables, setCuentasContables] = React.useState([])
  const [cuentaDestino, setCuentaDestino] = React.useState(null)

  React.useEffect(() => {
    async function fetchData() {
      await AsientoContableService.obtenerDetallexIdAsInfoCuenta(idEdicion).then(({ data }) => {
        if (data) {
          setCuentaDestino(data.cuentaDestino || null)
        }
      })
      await CuentaContableService.getCuentasContablesParaCAsSelect()
        .then(({ data }) => {
          setCuentasContables(data)
        })
        .catch(() => setCuentasContables([]))
    }
    fetchData()
  }, [idEdicion])

  const onSubmit = React.useCallback(() => {
    AsientoContableService.actualizarDetallexIdAsCuentaContableDestino(idEdicion, cuentaDestino)
      .then(() => {
        __zariContext.snack('success', 'Se ha actualizado los datos.')
        reloadTable()
        handleClose()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
      })
  }, [__zariContext, idEdicion, cuentaDestino, reloadTable, handleClose])

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>Editar cuenta destino</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group>
            <Form.Label text='DESTINO' htmlFor='select-cuentaDestino' md={12} />
            <Col md={12}>
              <Form.Select
                value={cuentaDestino}
                id='select-cuentaDestino'
                onChange={e => setCuentaDestino(e.target.value)}
              >
                <option value=''>Seleccionar</option>
                {cuentasContables.map((x, k) => (
                  <option key={k} value={x.value}>
                    {x.label}
                  </option>
                ))}
              </Form.Select>
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' outline onClick={handleClose}>
          Cancelar
        </Button>
        <Button onClick={onSubmit}>Guardar</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(EditarDestino)
